<template>
    <div class="container" v-loading="tableing">
        <div class="header">
            <div :class="['tabButton','tabb1',selectAction==1?'currentTab':'']" @click="tabChange('1')">{{veinQuest[rNGet].myExamList.tab1||'材料提交'}}<span v-show="selectAction==1" class="tabBtu-action"></span></div>
            <div :class="['tabButton','tabb2',selectAction==2?'currentTab':'']" @click="tabChange('2')">{{(rNGet=='guoyin'&&tab2TxtGATAccount? veinQuest['Dr'].myExamList.tab2:veinQuest[rNGet].myExamList.tab2)||'缴费与通知单下载'}}<span v-show="selectAction==2" class="tabBtu-action"></span></div>

            <el-dropdown trigger="click" class="rightDown" size="small">
                <span class="el-dropdown-link userinfo-inner userNameColorHd">
                    {{userInfo.idCardNoOmit||'账号操作'}}
                    <i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="width:88px;align-items: center;">
                    <el-dropdown-item @click.native="modifyPass()">修改密码</el-dropdown-item>
                    <el-dropdown-item divided @click.native="logOut()">注销登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <!-- <span class="HiddenMail" @click="copyClick"></span> -->
        </div>
        <div class="main" v-if="list&&list.length>0" ref="main">
            <div class="orgList" v-for="(item,index) in list" :key="index">
                <div class="orgList-bg">
                    <div class="orgList-top">
                        <p>{{item.paperName}}</p>
                        
                        <!-- 去填报 -->
                        <span
                            @click="comeList(item)"
                            class="bto-go orgList-text"
                            v-if="item.examStatus==0">
                            {{veinQuest[rNGet].myExamList.goBtu}} 
                            <img class="imgImg" src="../../../static/images/rightjiantou.png" alt="" srcset="">
                        </span>

                        <!-- <img v-if="item.examStatus==1" class="imgDui" src="../../../static/images/duibaise.png" alt="" srcset="">  -->
                        <!-- 已过期、已完成、待缴费、已缴费 -->
                         <span v-else class="orgList-text">
                            <!-- {{!veinQuest[rNGet].myExamList.canPay?item.isExaming:
                                item.examStatus==2?item.isExaming:
                                    (item.examSignOrderStatus?
                                        (item.examSignOrderStatus==20&&item.inExamTimeStatus==3?
                                            item.isExaming:item.orderStatusTxt[item.examSignOrderStatus])
                                            :item.isExaming)
                            }} -->
                            {{ kaoHouShowTxt(item)}}
                        </span>
                    </div>
                    <!-- <div class="orgList-center">
                        <div class="timeLong">
                            <span>
                                <i class="el-icon-time" style="font-weight: bold;"></i>
                                {{veinQuest[rNGet].myExamList.time||'填报时间'}}
                            </span>
                            <ul>
                                <li>{{item.ksTime}} 至</li>
                                <li>{{item.jsTime}}</li>
                            </ul>
                        </div>
                        <div class="timeLong" v-show="false"><i class="el-icon-collection"></i> {{`报考专业：${item.subjectName}`}}</div>
                        <div class="timeLong"><i class="el-icon-s-fold"></i> {{`状态：${item.isExaming}`}}</div>
                    </div> -->
                    <div class="orgList-bottom">
                        <el-button type="primary" size="small" v-if="item.showScore">查看成绩单</el-button>
                        <el-button type="success" size="small" v-if="item.showPay==20&&selectAction==2&&item.inExamTimeStatus==2" @click="statuComePay(item)">请缴纳报名费</el-button>
                        <el-button type="success" size="small" v-if="item.showPay==21&&selectAction==2" @click="statuComePay(item)">订单详情</el-button>
                        <el-button type="primary" size="small" v-if="item.showPay==21&&selectAction==2&&item.showTozhidan" @click="downloadTzd(item)" class="downTzdBtu">下载复试通知单</el-button>
                        <el-button type="danger" size="small" v-if="selectAction==2&&item.paperSubmitMsg" @click="lookBohuiClick(item)">驳回详情</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="currentNotData"></div>
        <!-- 准考证 -->
        <el-dialog
            class="ticketDialog"
            title="人员信息"
            :visible.sync="ticketDialog"
            :show-close="false"
            width="30%"
            center>
            <div class="bgRecarding">
                <!-- <div class="recard-head">
                    <div class="headImg-box">
                        <img :src="saveData.headUrl||(userInfo.faceUrl||errorImg)" class="headImg" alt="" srcset=""></img>
                    </div>
                </div> -->
                <div class="recard-body">
                    <table class="recard-table" style="width:100%;height:95%">
                        <tr>
                            <td style="width:30%;">姓名</td>
                            <td style="width:70%">{{saveData.idName}}</td>
                        </tr>
                        <tr>
                            <td>报名号</td>
                            <td>{{saveData.personNum||'-'}}</td>
                        </tr>
                        <!-- <tr>
                            <td>准考证号</td>
                            <td>{{saveData.ticketNum}}</td>
                        </tr> -->
                        <tr>
                            <td>填报时间</td>
                            <td>{{saveData.examStartDateVal}} -<br/> {{saveData.examEndDateVal}}</td>
                        </tr>
                        <tr>
                            <td>填报时长</td>
                            <!-- <td v-if="saveData.examMin!=-1">{{saveData.examMin}} 分钟</td> -->
                            <td>不限时</td>
                        </tr>
                        <tr>
                            <td>证件号码</td>
                            <td>{{saveData.idCardNo}}</td>
                        </tr>
                        <tr>
                            <td>{{veinQuest[rNGet].myExamList.subjectNameTxt||'报考专业'}}</td>
                            <td>{{saveData.subjectName}}</td>
                        </tr>
                        <tr v-if="false">
                            <td>填报级别</td>
                            <td>{{saveData.levelName}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="success" @click="goJinRukaoshi" class="sucRecard"> 下一步 </el-button>
            </span>
        </el-dialog>

        <!-- 驳回 -->
        <el-dialog
            title="驳回详情"
            :visible.sync="dialogUserPaperBohui"
            width="50%"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            class="dialogUserBohuiClass">
                <el-row :span="24">
                    <div class="sgdiv"><span>试卷名称：</span><span>{{saveData.paperName}}</span> </div>
                    <div class="sgdiv"><span>操作时间：</span><span>{{saveData.paperSubmitDateVal}}</span> </div>
                    <div class="sgdiv"><span>驳回原因：</span><span>{{saveData.paperSubmitMsg}}</span> </div>
                    <div class="textL" style="margin-top:20px;margin-left: 85.5px;">
                        <el-button
                            v-if="saveData.inExamTimeStatus==2" 
                            :type="saveData.inExamTimeStatus==2?'success':'info'"
                            size="small" 
                            @click="comeList(saveData,'bohui')" 
                            :class="[saveData.inExamTimeStatus==2?'':'disabledBohuiGoExamBtu']" 
                        >重新{{veinQuest[rNGet].myExamList.goBtu||'开始填报'}}
                        </el-button>
                        <span v-else style="color:red;">{{ `${saveData.inExamTimeStatus==1?'未开始':saveData.inExamTimeStatus==3?'已过期':'进行中'}，无法重新${veinQuest[rNGet].myExamList.goBtu||'开始填报'}！` }}</span>
                    </div>
                </el-row>
            </el-dialog>

        <prompt-mailbox ref="promptMailbox"></prompt-mailbox>
        <edit-pwd ref="editPwd"></edit-pwd>
        <to-pay-dialog ref="toPayDialog"></to-pay-dialog>
    </div>
</template>
<script>
import utils from '../../lib/util'
import editPwd from './editPwd'
import toPayDialog from '../../components/exam2/toPayDialog'
import { getDateNow } from '../../lib/youxunAPI';
import { saveAs } from 'file-saver';
    export default {
        name:"examList",
        data() {
            return {
                tableing:false,
                ticketDialog:false,
                dialogUserPaperBohui:false,
                selectAction:1,
                list:[],
                saveData:{},
                paperName:'',
                timeIter30:'',
                userInfo:'',
                jsonVal:'',
                padPort:'https://wap-sz.aitestgo.com/',
                padPortTest:'https://wap-test-sz.aitestgo.com/',
                errorImg: require('../../../static/images/img_loading_error.png'),
                tab2TxtGATAccount:'',//硕士 部分港澳台考生 不支付，避免文案歧义指定账号处理
            }
        },
        components:{
            editPwd,
            toPayDialog
        },
        beforeDestroy() {
            clearInterval(this.timeIter30)
        },
        computed:{
            rNGet: function () {
                return localStorage.getItem('roadName')?localStorage.getItem('roadName'):'guoyin'
            },
            kaoHouShowTxt(){
                return (item) => {
                    /**
                    examStatus 考试状态 0= 准备考试 1=考试完成 2=过期未考试
                    inExamTimeStatus  //1未开始 2考试中 3已结束
                    isExaming  暂未开始 已完成 已过期 进行中 已结束

                    不支付 显示isExaming
                    支付 
                        examStatus已过期2 显示isExaming
                        examStatus考试完成1 
                            examSignOrderStatus报名订单状态
                                无 显示isExaming
                                待缴费20 且 inExamTimeStatus已结束3 显示isExaming
                                其他 显示 订单状态对应文案

                     * */
                    let value = ''
                    if(!this.veinQuest[this.rNGet].myExamList.canPay){//非支付 博士
                        value = item.isExaming
                    }else{//有支付 硕士
                        if(item.examStatus==2){//已过期
                            value = item.isExaming
                        }else{
                            // 在硕士中 也可能创建非支付考试
                            if(item.examSignOrderStatus==undefined||item.examSignOrderStatus==null||item.examSignOrderStatus==''){
                                value = item.isExaming
                            }else{
                                if(item.examSignOrderStatus==20 && item.inExamTimeStatus==3){//待缴费 且 已结束
                                    value = item.isExaming
                                }else{
                                    value = item.orderStatusTxt[item.examSignOrderStatus] //支付了
                                }
                            }
                        }
                    }
                    return value
                }
            }
        },
        mounted(){
            let that = this
            that.tableing = true
            that.getUserInfo(function(){
                that.$nextTick(()=>{
                    that.tableing = false
                    that.tabChange(that.$route.query.tab?that.$route.query.tab:1)
                    that.addUdeskCn()
                    that.timeIter30 = setInterval(function(){
                        that.timeToCompare()
                    },30000)
                })
            })
            sessionStorage.removeItem('orgId')
        },
        methods:{
            tabChange(value=1){
                this.loadJsonData()
                this.selectAction = value
                if(this.tab2TxtGATAccount===''){}else{//非首次加载
                    this.getData()
                }
            },
            getUserInfo(callback=''){
                let that = this
                that.$axios.post('account/info',{
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                }, res => {
                    let v = res.data;
                    if (v.code == 0) {
                        that.userInfo = v.data
                        that.userInfo['idCardNoOmit'] = that.infoSensitive(that.userInfo.idCardNo)
                        that.userInfo['faceUrl'] = that.userInfo.faceUrl? `${that.userInfo.faceUrl}?x-oss-process=image/resize,m_lfit,h_149,w_103`:''
                    }else{
                        if(v.msg)
                            that.$message.error(v.msg);
                        else
                            that.$message.error('请求错误');
                    }
                    if(callback){
                        callback()
                    }
                })
            },
            infoSensitive(value){
                if(!value) return ''
                return value.replace(/^(.{2})(?:\w+)(.{3})$/, "\$1****\$2")
            },
            getData(){//考级
                let that = this
                that.tableing = true
                // 解决：交卷后返回到list，刚提交试卷不能及时出现在已完成中
                if(that.$route.query.del){
                    that.uploadHttpUrl()
                    window.setTimeout(function(){that.getData()},3000)
                    return
                }

                that.$axios.post('/v1/paper/mySignUplist',{
                    pageNum:1,
                    pageSize:1,
                    examStatus:that.selectAction,
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                }, res => {
                    that.tableing = false;
                    let v = res.data;
                    if (v.code == 0) {
                        that.list = []
                        v.data.list.forEach(element => {
                            if(element.orderStatus == 2) {
                                element['ksTime'] = element.examStartDateVal
                                element['jsTime'] = element.examEndDateVal
                                element['isExaming'] = "暂未开始"
                                element.headUrl = element.headUrl? `${element.headUrl}?x-oss-process=image/resize,m_lfit,h_149,w_103`:''
                                element['menuList'] = that.menuListSet(element)
                                element['orderStatusTxt'] = element.examSignOrderStatus? that.justOrderStatus(element.examSignOrderStatus):''
                                element['showScore'] = false
                                element['showTozhidan'] = false
                                element['showPay'] =  that.veinQuest[that.rNGet].myExamList.canPay&&element.examStatus==1&&element.examSignOrderStatus?element.examSignOrderStatus:0
                                element['inExamTimeStatus'] = 2 //1未开始 2考试中 3已结束
                                element['bohuiChongchuan'] = 0 //是否驳回重传 1去重传 0不重传  只有点击去重传按钮才变1
                                that.list.push(element)
                            }
                        });
                        that.timeToCompare();

                        that.uploadHttpUrl()
                    }else{
                        if(v.msg)
                            that.$message.error(v.msg);
                        else
                            that.$message.error('请求错误');
                    }
                })
            },
            // 更新链接
            uploadHttpUrl(){
                let that = this
                if(that.$route.query.tab)
                that.$router.replace({path:'/myExamList'})
            },
            //菜单配置
            menuListSet(item){
                let get_list = utils.menuListGet()
                let set_menu = []
                if(item.openDeviceCheck && Number(item.openDeviceCheck)==1)
                set_menu.push(get_list.indexOf('testManual'),get_list.indexOf('mkfDetection'))
                if(Number(item.joinYouXun)==1 && item.liveInfo && item.liveInfo.examNum)
                set_menu.push(get_list.indexOf('youXunCheck'))

                if( 
                    this.veinQuest[this.rNGet].myExamList.signPage &&
                    (this.rNGet=='guoyin' && !this.tab2TxtGATAccount)
                )
                set_menu.push(get_list.indexOf('signCommitment'))
                set_menu.push(get_list.indexOf('examination'))
                return set_menu.join()
            },
            // 查看是否到考试时间
            timeToCompare(){
                let that = this
                let poorTime = window.localStorage.getItem('poorVal')
                let timestamp2 = Date.parse(new Date());
                if(Number(poorTime)>=0){timestamp2 = Number(timestamp2) + Number(poorTime)}
                else{timestamp2 = Number(timestamp2) - Number(Math.abs(poorTime))}
                that.list.forEach(son => {
                    // examStatus 考试状态 0= 准备考试 1=考试完成 2=过期未考试
                    if(son.examStartDate<=timestamp2){
                        if(son.examEndDate<=timestamp2){
                            son.inExamTimeStatus = 3
                        }else{
                            son.inExamTimeStatus = 2
                        }
                    }else{
                        son.inExamTimeStatus = 1
                    }
                    if(son.examStatus==1){son.isExaming = "已完成"}
                    else if(son.examStatus==2){son.isExaming = "已过期"}
                    else{
                        son.isExaming = son.inExamTimeStatus==1?'未开始':son.inExamTimeStatus==2?'进行中':'已结束'
                    }
                    if(son.examStatus!=0){//1已完成、2过期
                        let value = false
                        const scoreTotime = this.jsonVal.scoreList[son.paperId]
                        if(scoreTotime){
                            const startTime = new Date(scoreTotime.split('-')[0]).getTime()
                            const endTime = new Date(scoreTotime.split('-')[1]).getTime()
                            if( startTime < timestamp2 && endTime > timestamp2 )
                            value = true
                        }
                        son.showScore = value
                        // son.showTozhidan = son.examStatus==1&&this.jsonVal.tozhidanList.includes(String(son.paperId))
                        if(son.examStatus==1&&this.jsonVal.tozhidanList.includes(String(son.paperId))){
                            this.fooTozhidanYesNo(son).then((fileYesNo)=>{
                                son.showTozhidan = fileYesNo
                            })
                        }else{
                            son.showTozhidan = false
                        }
                    }
                });
            },
            // 通知单是否存在
            fooTozhidanYesNo(item){
                return new Promise((resolve,reject)=>{
                    const devStr = process.env.NODE_ENV =='production'?'gyweb':'gywebtest';
                    const fUrl = `${process.env.NODE_ENV =='production'?this.padPort:this.padPortTest}${devStr}/TZD/${item.paperId}/${item.idCardNo}.pdf`
                    utils.checkRemoteFileExistence(fUrl)
                    .then((val)=>{
                        resolve(val)
                    })
                    .catch((val)=>{
                        resolve(false)
                    });
                })
            },
            comeList(item,type=''){
                let that = this
                if(type && type=='bohui' && item.inExamTimeStatus!=2){
                    that.$message({
                        message:`${item.inExamTimeStatus==1?'未开始':item.inExamTimeStatus==3?'已结束':'进行中'}，无法重新${that.veinQuest[that.rNGet].myExamList.goBtu||'开始填报'}！`,
                        duration:5000,
                        showClose: true,
                        type:'error',
                    })
                    return
                }
                that.ticketDialog = true
                that.saveData = item
                that.saveData.bohuiChongchuan = that.saveData.paperSubmitMsg&&type=='bohui'?1:0
            },
            goJinRukaoshi(){
                this.$nextTick(()=>{
                    this.$router.push({
                        path: `/${utils.menuListGet()[this.saveData.menuList.split(',')[0]]}`,
                        query: {
                            bId:this.saveData.paperId,
                            paperName:this.saveData.paperName,
                            userSignId:this.saveData.id,
                            idName:this.saveData.idName,
                            idCardNo:this.saveData.idCardNo,
                            ticketNum:this.saveData.ticketNum,
                            youXunExamId:this.saveData.youXunExamId,
                            youXunExamNum:this.saveData.youXunExamNum,
                            examStartDate:this.saveData.examStartDate,
                            examEndDate:this.saveData.examEndDate,
                            examStatus:this.saveData.examStatus,
                            examStartDateVal:this.saveData.examStartDateVal,
                            examEndDateVal:this.saveData.examEndDateVal,
                            examMin:this.saveData.examMin,
                            personNum:this.saveData.personNum,
                            reviewType:this.saveData.reviewType,
                            menuList:this.saveData.menuList,
                            bohuiChongchuan:this.saveData.bohuiChongchuan,
                            // tab2TxtGATAccount:this.tab2TxtGATAccount,
                        }
                    })
                    // 存储一个进入的唯一uuid
                     window.sessionStorage.setItem('toLastUuid',`${this.saveData.paperId}-${this.saveData.id}-${utils.uuid2(16)}`)
                })
            },
            logOut(){
                let that = this
                let isFlag = false
                that.list.forEach(son => {
                    if(son.isExaming=='进行中'&&son.examStatus!=1){
                        isFlag = true
                        return false;
                    }
                });
                let loginOutTitle = '请问是否退出账号？'
                if(isFlag)
                loginOutTitle = '请问是否退出账号？'
                this.$confirm(`${loginOutTitle}`, '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '退出',
                    cancelButtonText: '再想想',
                    type:'warning'
                })
                .then(() => {
                    localStorage.removeItem('poorVal')
                    let roadNameVal = window.localStorage.getItem('roadName')
                    let paramVal = roadNameVal&&roadNameVal!='guoyin'? `/${roadNameVal}`:''
                    this.$router.push({
                        path: `${paramVal}/login`,
                    })
                })
                .catch(action => {});
            },
            // 去支付
            statuComePay(item){
                this.$refs.toPayDialog.open(item)
            },
            modifyPass(){
                this.$refs.editPwd.open(this.userInfo)
            },
            downloadTzd(item){
                // 1 判断是否有该文件 2下载
                const devStr = process.env.NODE_ENV =='production'?'gyweb':'gywebtest';
                const fUrl = `${process.env.NODE_ENV =='production'?this.padPort:this.padPortTest}${devStr}/TZD/${item.paperId}/${item.idCardNo}.pdf`
                let that = this
                utils.checkRemoteFileExistence(fUrl)
                .then((val)=>{
                    if(!val){
                        that.$message({
                            message:"未查询到通知单！",
                            duration:5000,
                            showClose: true,
                            type:'error',
                        })
                        return
                    }
                    // 下载 
                    that.downloadPdf(fUrl,`${item.idCardNo}.pdf`)
                })
                .catch((val)=>{})
            },
            downloadPdf(pdfUrl, fileName) {
                // 从 PDF 文件的 URL 获取 Blob 对象
                fetch(pdfUrl)
                .then(response => response.blob())
                .then(blob => {
                    // 使用 FileSaver.js 的 saveAs 函数保存文件
                    saveAs(blob, fileName);
                })
                .catch(error => {
                    console.error('Error downloading PDF:', error);
                });
            },
            lookBohuiClick(item){
                this.saveData = item
                this.dialogUserPaperBohui = true
            },
            copyClick(){
                this.$prompt('请输入特定的的操作密码？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputType:'password',
                    inputErrorMessage: '密码不能为空',
                    inputValidator: (value)=>{
                        if(value.trim().length < 1){
                            return '输入不能为空'
                        }
                    },
                    beforeClose: (action, instance, done)=>{
                        if(action == 'confirm'){
                            let value = instance.inputValue
                            if(value != '123457'){
                                this.$message.error('操作密码输入错误！')
                            }else{
                                this.$refs.promptMailbox.open()
                                done()
                            }
                        }else{
                            done()
                        }
                    },
                    callback: function (action, instance) {}
                })
            },
            loadJsonData() {
                let that = this
                let urlFace = process.env.NODE_ENV =='development'?'':process.env.NODE_ENV =='testing'?'/gywebtest':'/gyweb'
                utils.getJson(`${urlFace}/static/doc/guoyinSet.json`)
                .then(data => {
                    that.jsonVal = data

                    if(that.tab2TxtGATAccount==='')//首次加载
                    that.tabTextZhidingAccount()
                })
                .catch(error => {
                    console.error('Error fetching JSON:', error);
                });
            },
            tabTextZhidingAccount(){
                if(
                    this.jsonVal.tab2ShuoshiGATAccount &&
                    this.jsonVal.tab2ShuoshiGATAccount.length>0
                ){
                    this.tab2TxtGATAccount = this.jsonVal.tab2ShuoshiGATAccount.includes(this.userInfo.idCardNo)
                }else{
                    this.tab2TxtGATAccount = false
                }
                this.getData()
            },
            justOrderStatus(item) {
                var zhOrderStatus = [
                    { 0: "新订单" },
                    { 1: "已取消", bg: "#FA6400" },
                    { 2: "已取消", bg: "#FA6400" },
                    { 3: "已删除", bg: "#F84705" },
                    { 4: "已删除", bg: "#F84705" },
                    { 10: "待审核", bg: "#409EFF" },
                    { 11: "审核通过" },
                    { 12: "完善信息" },
                    { 20: "待缴费", bg: "#1B4BAD" },
                    { 21: "已缴费", bg: "#1FCA6E" },
                    { 22: "已收款", bg: "#07c160" },
                    { 30: "待退款" },
                    { 31: "退款成功", bg: '#CB4B14' },
                    { 40: "待发货" },
                    { 41: "待收货" },
                    { 42: "签收成功" },
                    { 99: "完成", bg: "#1FCA6E" }
                ];
                var value = zhOrderStatus.find(ele => {
                    return Object.keys(ele)[0] == item;
                });
                return value;
            },
            addUdeskCn(){
                (function(a,h,c,b,f,g){a["UdeskApiObject"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};g=h.createElement(c);g.async=1;g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)})
                (window,document,"script","https://wap-sz.aitestgo.com/showOnly/udeskApi.js?ut=1709691420931","ud");
                ud({
                    "code": "2f0k97h2",
                    "link": "https://ata.s2.udesk.cn/im_client_nocdn/?web_plugin_id=61482",
                    "onlineText": "客服",
                    "offlineText": "留言",
                    "pos_flag": "hrm",
                });
                this.$nextTick(()=>{
                    let kFu = document.getElementById('udesk_container')
                    if(kFu)
                    kFu.style.display = "inherit"
                })
            },
        },
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
    }
    .header{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        color: #000;
        border-bottom: 1px solid #EDEEED;
        .tabButton{
            position: absolute;
            top: 20px;
            height: 30px;
            line-height: 20px;
            padding: 0;
            font-size: 16px;
            color: #716778;
            border: 0px;
            cursor: pointer;
            background: transparent;
        }
        .currentTab{
            color: #000;
            font-size: 17px;
            font-weight: bold;
        }
        .tabBtu-action{
            display: inline-block;
            position: absolute;
            bottom: 0px;
            left: 0%;
            height: 2px;
            width: 100%;
            background: #449EFC;
            border: 0px;
            -webkit-animation: widthTab 0.5s linear;
            -moz-animation: widthTab 0.5s linear;
            -ms-animation: widthTab 0.5s linear;
            -o-animation: widthTab 0.5s linear;
            animation: widthTab 0.5s linear;
        }
        @keyframes widthTab {
            0%{ width: 0%;left: 50%;}
            100%{ width: 100%; left: 0%;}
        }
        .tabb1{left: 10%;}
        .tabb2{left: 20%;}
        .rightDown{
            position: absolute;
            top: 0px;
            right: 10%;
            color: #000;
            font-size: 16px;
            height: 100%;
        }
        .userNameColorHd{
            cursor: pointer;
        }
        .userNameColorHd:hover{
            color: #409eff;
        }
        .HiddenMail{
            height: 27px;
            width: 27px;
            display: inline-block;
            position: absolute;
            top: 18px;
            right: 21%;
            cursor: pointer;
            background: url('../../../static/images/hiddenMail.png');
            background-repeat: no-repeat;
            background-position: 50% 50%;
            background-size: 100% 100%;
        }
    }
    .currentNotData,
    .main{
        position: absolute;
        top: 75px;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        overflow-y: auto;
    }
    .currentNotData{
        background-image: url('../../../static/images/noData.png');
        background-position: 50% 50%;
        background-size: auto 50%;
        background-repeat: no-repeat;
    }
    .orgList{
        background-color:#1D4BAF;
        // height: 115px;
        // height: 70px;
        height: auto;
        width: 80%;
        margin: 0 auto;
        display: block;
        margin-bottom: 20px;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); 
        // position: relative;
    }
    .orgList-bg{
        // position: absolute;
        // left: 0;
        // top: 0;
        // height: 100%;
        width: 100%;
        background-image: url('../../../static/images/bg_top-1.png'),url('../../../static/images/bg_top-2.png');
        background-repeat: no-repeat;
        background-size: 7% 31%,9% 40%;
        background-position: 100% 100%,0px 0px;
        box-sizing: border-box;
    }   
    .orgList:hover {
        background-color: #1442a5;
        .orgList-center{
            background-color: #013177;
        }
    } 
    .orgList-top{
        height: 63px;
        width: 90%;
        margin-left: 5%;
    }
    .orgList-top p{
        height: 40px;
        position: relative;
        left: 0;
        top: 15px;
        width: 82%;
        color: #fff;
        font-size: 20px;
        text-align: left;
        line-height: 40px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .orgList-text{
        float: right;
        width: 15%;
        height: 30px;
        min-width: 106px;
        position: relative;
        top: -20px;
        right: 0px;
        box-sizing: border-box;
        line-height: 30px;
        text-align: center;
        // display: inline-block;
        font-family: STHeiti;
        font-size: 15px;
        color: #fff;
        font-weight: bold;
        border-radius: 4px;
        cursor: pointer;
        i{
            vertical-align: middle;
            margin-top:-3px;
        }
        i::before{
           margin-left: 1px;
           color: #000; 
           font-size: 18px;
        }
        .imgDui{
            margin-bottom: -1px;
            margin-left: 5px;
            width: 15px;
        }
        .imgImg{
            height: 13px;
            width: 15px;
            margin-bottom: -1px;
            margin-left: 5px;
        }
    }
    .bto-suc{
        background:#ECAD00;
        cursor: default;
    }
    .bto-go{
        background: #1BCA67;
    }
    .bto-end{
        background: darkcyan;
        cursor: default;
    }
    .orgList-center{
        height: 39px;
        width: 90%;
        margin-left: 5%;
        margin-bottom: 10px;
        background-color: #003B91;
        color: #fff;
        position: relative;
    }
    .orgList-bottom{
        // height: 39px;
        height: auto;
        width: 90%;
        margin-left: 5%;
        text-align: left;
        margin-top: 1px;
        box-sizing: border-box;
        padding-bottom: 8px;
        .downTzdBtu{
            background-color: #E59000;
            border-color: #E59000;
        }
        .downTzdBtu:hover{
            background-color: #fb9f03;
            border-color: #fb9f03;
        }
    }
    .timeLong{
        width: 37%;
        height:39px;
        display: inline-block;
        font-size: 15px;
        font-weight: 500;
        text-align: left;
        font-family: STHeiti;
        font-style: unset;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 39px;
    }
    .orgList-center .timeLong:nth-child(1){
        position: absolute;
        left: 1%;
        width: 40%;
        span{
            float: left;
            width: 95px;
            display: inline-block;
        }
        ul{
            float: left;
            display: inline-block;
            width: calc( 100% - 95px );
            li{
                height: 19.5px;
                line-height: 20px;
                &:nth-child(1){
                    line-height: 25px;
                }
                &:nth-child(2){
                    line-height: 15px;
                }
            }  
        }
    }
    .orgList-center .timeLong:nth-child(2){
        position: absolute;
        left: 42%;
        width: 35%;
    }
    .orgList-center .timeLong:nth-child(3){
        position: absolute;
        right: 2%;
        // width: 20%;
        width: 30%;
    }
    .sgdiv{
        font-size: 15.5px;
        width: 100%;
        text-align: left;
        margin: 5px 0;
        display: flex;
        align-items: flex-start;
    }
    .sgdiv span:first-child {
        white-space: nowrap;
        margin-right: 8px;
        flex-shrink: 0;
        font-weight: bold;
    }

    .sgdiv span:nth-child(2){
        word-break: break-word;
        flex: 1;
    }
</style>
<style>
    .ticketDialog .el-dialog{
        width: 450px !important;
        /* height: 89% !important; */
        height: 510px !important;
        max-height: 700px !important;
        min-height: 510px !important;
    }
    .ticketDialog .el-dialog__header{
        height: 45px;
        padding: 0 !important;
        box-sizing:border-box;
    }
    .ticketDialog .el-dialog__header .el-dialog__title{
        display: block !important;
        height: 100%;
        line-height: 45px;
    }
    .ticketDialog .el-dialog__body{
        height: 87%;
        padding: 0 !important;
        box-sizing: border-box;
        padding-top: 45px !important; 
        margin-top: -45px !important; 
    }
    .ticketDialog .el-dialog .el-dialog__footer{
        height: 13%;
        box-sizing: border-box;
    }
    .ticketDialog .el-dialog__body .bgRecarding{
        height: 100%;
        width: 100%;
    }
    .ticketDialog .el-dialog__body .bgRecarding .recard-head{
        height: 30%;
        width: 100%;
        border-bottom: 10px solid #F0F1F0;
        box-sizing: border-box;
        position: relative;
    }
    .ticketDialog .el-dialog__body .bgRecarding .recard-head .headImg-box{
        position: absolute;
        top: 5px;
        bottom: 5px;
        width: 23%;
        left: 0;
        right: 0;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .headImg-box .headImg{
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
    }
    .ticketDialog .el-dialog__body .bgRecarding .recard-body{
        height: 96%;
        width: 100%;
        border-bottom: 10px solid #F0F1F0;
        padding-top: 10px;
        padding-bottom: 10px;
        box-sizing: border-box;
    }
    .ticketDialog .el-dialog .el-dialog__header{
        background: #1D4BB0;
    }
    .ticketDialog .recard-table tr>td:nth-child(1){
        text-align: center;
        color: #12499C;
        font-size: 17px;
    }
    .ticketDialog .recard-table tr>td:nth-child(2){
        text-align: left;
        color: #000;
        font-size: 15px;
    }
    .ticketDialog .el-dialog .el-dialog__footer .dialog-footer{
        display: block;
        height: 100%;
        width: 100%;
        position: relative;
    }
    .ticketDialog .el-dialog .el-dialog__footer .sucRecard{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        height: 37px;
        margin: auto;
        background: #1D4BB0;
        width: 50%;
        border-color: transparent !important;
    }
    .dialogUserBohuiClass .el-dialog{
        min-width: 700px;
        max-width: 750px;
    }
    .dialogUserBohuiClass .el-dialog .el-dialog__header{
        background: #1D4BB0 !important;
    }
    .disabledBohuiGoExamBtu.el-button{
        
    }
</style>


// WEBPACK FOOTER //
// src/pages/myExamList/myExamlist.vue